import * as React from "react";
import { IconProps } from "./types";

export default function Briefcase({ svgProps, pathProps }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M4 22C3.45 22 2.98 21.8 2.59 21.41C2.2 21.02 2 20.55 2 20V9C2 8.45 2.2 7.98 2.59 7.59C2.98 7.2 3.45 7 4 7H8V5C8 4.45 8.2 3.98 8.59 3.59C8.98 3.2 9.45 3 10 3H14C14.55 3 15.02 3.2 15.41 3.59C15.8 3.98 16 4.45 16 5V7H20C20.55 7 21.02 7.2 21.41 7.59C21.8 7.98 22 8.45 22 9V20C22 20.55 21.8 21.02 21.41 21.41C21.02 21.8 20.55 22 20 22H4ZM10 7H14V5H10V7ZM20 16H15V18H9V16H4V20H20V16ZM11 16H13V14H11V16ZM4 14H9V12H15V14H20V9H4V14Z"
        fill="currentColor"
        {...pathProps}
      />
    </svg>
  );
}
